import type { track as TrackFn } from "pro-features/components/WithTrack/src/context";
import createSignalsColumnsTrackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-columns/factory";
import createSignalsFiltersTrackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-filters/factory";
import createSignalsmanagementTrackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-management/factory";

import type SignalFilters from "../../models/core/SignalFilters";
import type { SignalTimeframe } from "../../models/miscellaneous/SignalTimeframe";
import type UISignal from "../../models/view/UISignal";

export default function createSignalsTrackingService(track: TrackFn) {
    const trackSignalsDropdownEvent = (action: string, name: string) => {
        track("signals dropdown", action, name);
    };

    const trackEditSignalEvent = (action: string, name: string) => {
        track("edit signal", action, name);
    };

    return {
        management: createSignalsmanagementTrackingService(track),
        filters: createSignalsFiltersTrackingService(track),
        columns: createSignalsColumnsTrackingService(track),

        trackHoverCustomTag() {
            trackSignalsDropdownEvent("hovered signal changes tag", "signal changes tag");
        },

        trackIntentSelectTopics() {
            trackSignalsDropdownEvent("click select topics", "");
        },
        trackTimeframeSelected(timeframe: Readonly<SignalTimeframe>, uiSignal: Readonly<UISignal<SignalFilters>>) {
            trackEditSignalEvent(
                "change time period for signal",
                `${timeframe.amount} ${timeframe.id}/${uiSignal.template.alias}/${uiSignal.signalType}`,
            );
        },
    };
}
